










































    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import PageRequest from '@/store/entities/page-request'
    import { Component,Watch } from 'vue-property-decorator'
    import Ajax from '../../lib/ajax'
    class  PageMediaRequest extends PageRequest{
        keyword:string;
    }
    @Component
    export default class VFiles extends AbpBase {
        pagerequest:PageMediaRequest=new PageMediaRequest();
        intervalId:any=null;
        progressVal:number=0;
        progressVis:boolean=false;
        progressStatus:string="active"
        ftpIsActive:boolean = Util.abp.setting.getBoolean("App.FtpIsActive");
        ftpServerMediaPath:string = Util.abp.setting.get('App.ServerMediaPath');
        // get progressVal(){
        //     return this.$store.state.mediamanager.progressVal;
        // }
        get list(){
            return this.$store.state.vfiles.list;
        }
        get loading(){
            return this.$store.state.medialist.loading;
        }
        get pageSize(){
            return this.$store.state.vfiles.pageSize;
        }
        get totalCount(){
            return this.$store.state.vfiles.totalCount;
        }
        get currentPage(){
            return this.$store.state.vfiles.currentPage;
        }
        async changeIsActive(status) {
            await this.$store.dispatch({
            type: "options/isFtpActive",
            data: { active: status },
            });
            this.ftpIsActive = status;
            Util.abp.setting.set("App.FtpIsActive",status.toString())
        }
        uploadFile(efile){
            const self = this; 
            this.progressVal = 0;
            this.progressVis = true;
            this.intervalId = setInterval( function(){
                self.progress();
            }.bind(this), 800);
            let formData = new FormData();;
            for(let index=0; index<1; index++)
            {
                formData.append('files', efile);
            } 
            formData.append('responsibleUserId', Util.abp.session.userId);
            this.$store.commit('medialist/setLoading',true);
            this.$store.dispatch({
                type: "mediamanager/createVFileItems",
                data: formData
            }).then( ()=> {
                this.getpage();
                this.$store.commit('medialist/setLoading',false);
                this.stopUpdatingProgressIndicator();
                this.progressVal = 100;
                this.progressVis = false;
            })
            .catch(
                ( err ) => {
                    this.$store.commit('medialist/setLoading',false);
                    this.stopUpdatingProgressIndicator();
                    this.progressVal = 100;
                    this.progressVis = false;
                    this.$Modal.error({title:this.L('Error'),content:this.L('FileUploadError')});
                    console.log("Plik błąd")
                    console.log(err);
                    return false;
            });
            return false;
        }
        pageChange(page:number){
            this.$store.commit('vfiles/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('vfiles/setPageSize',pagesize);
            this.getpage();
        }
        async getpage(){         
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            //filters            
            await this.$store.dispatch({
                type:'vfiles/getAll',
                data:this.pagerequest
            })
        }
        dwonloadAttachment(url,filename,customName){
            var fileExt = '.' + filename.split('.').pop();
            Ajax.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = customName + fileExt;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        }
        async progress(){
            let result = await this.$store.dispatch({
                type: "mediamanager/progress",
            })
            this.progressVal = result;
        }     
		stopUpdatingProgressIndicator() {
			clearInterval(this.intervalId);
		}
        columns=[
        {            
            title:this.L('File'),
            width:80,
            render:(h:any,params:any)=>{
                return h('div',[                   
                    h('Button',{
                        props:{
                            type:'primary',
                            icon:'md-download',
                            ghost:'',
                        },
                        ghost:'',
                        on:{
                            click:async ()=>{                             
                                this.dwonloadAttachment(params.row.fileWebPath,params.row.fileName, params.row.customName);
                            }
                        }
                    },)
                ])
            }
        },
        {
            title:this.L('CustomName'),
            key:'customName'
        },
        {
            title:this.L('FileName'),
            key:'fileName'
        }
        ,{
            title:this.L('Actions'),
            key:'Actions',
            width:150,
            render:(h:any,params:any)=>{
                return h('ButtonGroup',{props:{vertical:''}},[                   
                    h('Button',{
                        props:{
                            type:'primary',
                            icon:'md-arrow-up',
                            ghost:'',
                        },
                        ghost:'',
                        on:{
                            click:async ()=>{
                                await this.$store.dispatch({
                                    type:'vfiles/down',
                                    data:params.row
                                }).then( async ()  => {
                                    await this.getpage();
                                })                                
                            }
                        }
                    },),
                        h('Button',{
                        props:{
                            type:'error',
                            icon:'md-trash',
                            ghost:'',
                        },
                        ghost:'',
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L('DeleteMediaConfirm'),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                            await this.$store.dispatch({
                                                type:'vfiles/delete',
                                                data:params.row
                                            })
                                            await this.getpage();
                                        }
                                })
                            }
                        }
                    },),
                        h('Button',{
                        props:{
                            type:'primary',
                            icon:'md-arrow-down',
                            ghost:'',
                        },
                        ghost:'',
                        on:{
                            click:async ()=>{
                                await this.$store.dispatch({
                                    type:'vfiles/up',
                                    data:params.row
                                }).then( async ()  => {
                                    await this.getpage();
                                })                                    
                            }
                        }
                    },)
                ])
            }
        }]
        async search(){
            this.$store.commit('vfiles/setCurrentPage',1);
            this.getpage();
        }
        async created(){
            this.getpage();
        }
    };
